import React, { FC } from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { DateInput, TextInput } from "@/components/atoms";
import { CustomerCardFormType } from "@/components/features/ToDos/CustomerCardPage/formType";
import { RefSelectInput } from "@/components/molecules";

const Identity: FC = () => {
    const { control } = useFormContext<CustomerCardFormType>();
    const { t } = useTranslation();

    return (
        <>
            <TextInput
                name="identity.idNumber"
                label={t("CustomerCard.IdentityCard.CardNumber")}
                autoComplete="off"
                control={control}
            />
            <DateInput
                name="identity.validFrom"
                control={control}
                disableFuture
                label={t("CustomerCard.IdentityCard.ValidFrom")}
            />
            <DateInput
                name="identity.validTo"
                control={control}
                disablePast
                label={t("CustomerCard.IdentityCard.ValidTo")}
            />
            <TextInput
                name="identity.issuedBy"
                label={t("CustomerCard.IdentityCard.Authority")}
                autoComplete="off"
                control={control}
            />
            <TextInput
                name="identity.nationalRegistryNumber"
                label={t("CustomerCard.IdentityCard.NationalNumber")}
                autoComplete="off"
                control={control}
            />
            <RefSelectInput name="personal.nationality.id" control={control} table="nationality" />
        </>
    );
};

export default Identity;
